export default __webpack_public_path__ + "fonts/IntelligenceIcon_Small.svg";